import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { SessionService } from "../../../../@core/session/session.service";
import { Store } from "../../../../@core/store/store";
import {
  profileImageLoadedState,
  profileImageLoadingErrorState,
  profileImageLoadingState,
} from "../../../../@core/session/session.state";
import { NbDialogRef } from "@nebular/theme";
import { AppLocalStorage } from "../../../../@core/utils/local-storage.util";
import { environment } from "../../../../../environments/environment";

@Component({
  selector: "ltts-people-details",
  templateUrl: "./people-details.component.html",
  styleUrls: ["./people-details.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class PeopleDetailsComponent implements OnInit {
  peopleInfo: any;
  peopleImage: any;
  private cmsbase_url: string;
  @Input() set peopleDetails(val) {
    this.peopleInfo = val;
    if (this.peopleInfo) {
      this.getProfileImage();
    }
  }

  constructor(
    private sessionService: SessionService,
    protected dialogRef: NbDialogRef<PeopleDetailsComponent>
  ) {}


  ngOnInit(){
    this.cmsbase_url = environment.CMSURL_IMG
  }

  closeDialog() {
    this.dialogRef.close();
  }

  getProfileImageSrc(image: string): string {
    if (image && image.startsWith("data:image/png;base64,")) {
      return image;
    }
    if (image && !image.startsWith("data:image/png;base64,")) {
      return "data:image/png;base64," + image;
    }
    return this.cmsbase_url+"wp-content/uploads/2025/05/dumy.jpg";
  }

  getProfileImage() {
    const me = this;

    const id = [this.peopleInfo.mail];

    if(AppLocalStorage.get("PROFILE_IMAGE", "PROFILE_IMAGE"+String(id).toLowerCase())){
        me.peopleImage = AppLocalStorage.get("PROFILE_IMAGE", "PROFILE_IMAGE"+String(id).toLowerCase())[0]?.userImage;
    }else{
      me.sessionService.getProfileImage(id).subscribe((state: Store.State) => {
        if (state instanceof profileImageLoadingState) {
          return;
        }
        if (state instanceof profileImageLoadedState) {
          this.peopleImage = state.data.data[0]?.userImage;
          return;
        }
        (state: profileImageLoadingErrorState) => {
          return;
        };
      });
    }
  }
}
